import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { editContact, createContact } from '../../actions'

import { Form, Input, Row, Col, Button, Checkbox } from 'antd'
const FormItem = Form.Item
const { TextArea } = Input

const formItemStyle = {
  style: {
    marginBottom: 0
  }
}

class ContactForm extends Component {
  state = {
    editing: false
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form, match: { params }, contact, editContact, createContact, nav } = this.props

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (contact) {
          editContact(params.projectId, contact.id, values, nav.contact.action)
          this.setState({ editing: false })
        } else {
          createContact(params.projectId, values)
        }
      }
    })
  }

  cancel = () => {
    const { form } = this.props

    form.resetFields()
    this.setState({ editing: false })
  }

  render () {
    const { contact, loading, form: { getFieldDecorator }, nav } = this.props
    const { editing } = this.state

    // form fields are disabled by default when adding new Contact log - editing Contact
    const isDisabled = nav.contact.action === 'call' && !editing

    return (
      <Form onSubmit={this.handleSubmit}>

        <Row gutter={10}>
          <Col span={8}>
            <FormItem label='Salutation' {...formItemStyle}>
              {getFieldDecorator('salutation', {
                initialValue: (contact && contact.salutation) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label='First name' {...formItemStyle}>
              {getFieldDecorator('firstName', {
                initialValue: (contact && contact.firstName) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label='Last name' {...formItemStyle}>
              {getFieldDecorator('lastName', {
                initialValue: (contact && contact.lastName) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={10}>
          <Col span={8}>
            <FormItem label='Company' {...formItemStyle}>
              {getFieldDecorator('company', {
                initialValue: (contact && contact.company) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label='Function' {...formItemStyle}>
              {getFieldDecorator('function', {
                initialValue: (contact && contact.function) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label='Email' {...formItemStyle}>
              {getFieldDecorator('email', {
                initialValue: (contact && contact.email) || null,
                rules: [
                  {
                    type: 'email',
                    message: 'Not a valid email'
                  }
                ]
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={10}>
          <Col span={8}>
            <FormItem label='City' {...formItemStyle}>
              {getFieldDecorator('city', {
                initialValue: (contact && contact.city) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label='Address' {...formItemStyle}>
              {getFieldDecorator('address', {
                initialValue: (contact && contact.address) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label='Zip' {...formItemStyle}>
              {getFieldDecorator('zip', {
                initialValue: (contact && contact.zip) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={10}>
          <Col span={12}>
            <FormItem label='Phone central' {...formItemStyle}>
              {getFieldDecorator('phoneCentral', {
                initialValue: (contact && contact.phoneCentral) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label='Phone direct' {...formItemStyle}>
              {getFieldDecorator('phoneDirect', {
                initialValue: (contact && contact.phoneDirect) || null
              })(<Input disabled={isDisabled} />)}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={10}>
          <Col span={24}>
            <FormItem label='Comment' {...formItemStyle}>
              {getFieldDecorator('comment', {
                initialValue: (contact && contact.comment) || null
              })(<TextArea autosize={{ minRows: 2, maxRows: 5 }} disabled={isDisabled} />)}
            </FormItem>
          </Col>
        </Row>

        {/* edit 'isInCall' value - in case some agent was in a call with the contact,
            but something went wrong (he closed the window) */}
        {nav.contact.action !== 'call' &&
          <Row gutter={10}>
            <Col span={24}>
              <FormItem>
                {getFieldDecorator('isInCall', {
                  initialValue: (contact && contact.isInCall) || false,
                  valuePropName: 'checked'
                })(<Checkbox disabled={isDisabled}>Contact is in call</Checkbox>)}
              </FormItem>
            </Col>
          </Row>}

        <div style={{ marginTop: 20, textAlign: 'right' }}>
          {contact
            ? <div>
              {isDisabled && !loading.editContact
                  ? <Button type='primary' onClick={() => this.setState({ editing: true })}>Edit</Button>
                  : <div>
                    <Button
                      type='primary'
                      htmlType='submit'
                      style={{ marginRight: 10 }}
                      loading={loading.editContact}
                      >
                        Save
                      </Button>
                    {nav.contact.action === 'call' &&
                    <Button onClick={() => this.cancel()} loading={loading.editContact}>
                          Cancel
                        </Button>}

                  </div>}
            </div>
            : <Button type='primary' htmlType='submit' loading={loading.createContact}>
                Add
              </Button>}
        </div>

      </Form>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading,
  nav: state.nav
})

const mapDispatchToProps = {
  editContact,
  createContact
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(withRouter(ContactForm)))



// WEBPACK FOOTER //
// ./src/components/ContactModal/ContactForm.js